<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.settings.index` | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-container fluid>
        <h4>{{ `app.settings.admin.promotion.promotion`|trans }}</h4>
        <v-form>
          <v-layout row wrap>
            <v-flex xs12>
              <v-img
                  class="elevation-3"
                  v-if="promotion.image"
                  :src="`/storage/promo/`+promotion.image"
                  :width="500"
              ></v-img>
              <input
                  class="hidden"
                  type="file"
                  ref="image"
                  multiple="multiple"
                  accept="image/*"
                  @change="filesChange"
              >
              <div class="mt-3 mb-3">
                <v-btn :disabled="isLoading" v-if="promotion.image" :class="{'ml-0':promotion.image}" color="cancel"
                       @click="removeFile()">{{ 'app.remove_file' | trans }}
                </v-btn>
                <v-btn :disabled="isLoading" color="primary" :class="{'ml-0':!promotion.image}"
                       @click="filesButtonClick()">{{ 'app.chose_file' | trans }}
                </v-btn>
                <v-label>{{ selectedFilesLabels }}</v-label>
              </div>
              <v-text-field v-model="promotion.url" solo :label="`app.settings.admin.promotion.url`|trans">
              </v-text-field>
              <h5>{{ `app.settings.admin.promotion.status`|trans }}</h5>
              <v-checkbox
                  v-model="promotion.enabled"
                  class="ml-4"
                  :label="`app.settings.admin.promotion.enabled`|trans"
                  :color="`success`"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
        <loading-button class="pull-right" :loaging="isLoading" :status="status" @click="updatePromotion()">
          <i class="fa fa-save"></i> {{ `app.save`|trans }}
        </loading-button>
      </v-container>
      <v-divider></v-divider>
      <v-container fluid>
        <h4>{{ `app.settings.admin.information.information`|trans }}</h4>
        <v-form>
          <v-layout row wrap>
            <v-flex xs12>
              <v-textarea solo :auto-grow="true" :full-width="true" v-model="information.content"></v-textarea>
            </v-flex>
            <v-flex xs6>
              <h5>{{ `app.settings.admin.information.visibility`|trans }}</h5>
              <v-checkbox
                  v-model="information.preview"
                  class="ml-4"
                  :label="`app.settings.admin.information.admin`|trans"
                  :color="`success`"
              ></v-checkbox>
              <v-checkbox
                  v-model="information.enabled"
                  class="ml-4"
                  :label="`app.settings.admin.information.user`|trans"
                  :color="`success`"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
        <loading-button class="pull-right" :loaging="isLoading" :status="status" @click="updateInformation()">
          <i class="fa fa-save"></i> {{ `app.save`|trans }}
        </loading-button>
      </v-container>
      <v-divider></v-divider>
      <v-container fluid>
        <h4>{{ `app.settings.admin.payments.payments`|trans }}</h4>
        <v-form>
          <v-layout row wrap>
            <v-flex xs6>
              <h5>{{ `app.settings.admin.payments.active_payments`|trans }}</h5>
              <v-checkbox
                  v-model="payments.payu"
                  class="ml-4"
                  :label="`app.settings.admin.payments.payu`|trans"
                  :color="`success`"
              ></v-checkbox>
              <v-checkbox
                  v-model="payments.p24"
                  class="ml-4"
                  :label="`app.settings.admin.payments.p24`|trans"
                  :color="`success`"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
        <loading-button class="pull-right" :loaging="isLoading" :status="status" @click="updatePayments()">
          <i class="fa fa-save"></i> {{ `app.save`|trans }}
        </loading-button>
      </v-container>
    </v-app>
  </base-layout>
</template>
<script>
import {trans} from "../../../app";

export default {
  props: {
    routes: Object
  },
  data: () => ({
    isLoading: false,
    status: '',
    information: {
      content: '',
      preview: false,
      enabled: false
    },
    promotion: {
      enabled: false,
      url: null,
      image: null
    },
    payments: {
      payu: true,
      p24: false,
    },
    selectedFilesLabels: '',
    imageChanged: false
  }),
  created() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      axios.get(this.routes.data)
          .then((response) => {
            const data = response.data;
            this.information = data.information;
            this.promotion = data.promotion;
            this.selectedFilesLabels = this.promotion.image;
            this.payments = data.payments;
          })
          .catch((error) => {
            this.sentryCaptureException(error);
          })
    },
    updatePromotion() {
      this.isLoading = true;
      let formData = new FormData();
      formData.set('enabled', this.promotion.enabled)
      formData.set('url', this.promotion.url === null ? '' : this.promotion.url);
      if (typeof this.$refs.image !== 'undefined') {
        const files = this.$refs.image.files;
        if (files.length) {
          const file = files[0];
          formData.append('image', file)
          this.imageChanged = true;
        }
      }
      axios.post(`/administrator/settings/promotion?_method=PUT`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(() => {
        this.status = true;
        this.$toast.success(trans('app.actions.saved', {name: trans('app.pages.settings.index').toLowerCase()}));
        if (this.imageChanged) {
          this.loadSettings();
        }
      }).catch((error) => {
        this.status = false;
        if (error.response && error.response.status === 422) {
          this.$toast.error(trans('app.save_failed'));
        } else {
          this.sentryCaptureException(error);
        }
      }).finally(() => {
        this.isLoading = false;
        this.imageChanged = false;
      });
    },
    updateInformation() {
      this.isLoading = true;
      axios.put(`/administrator/settings/information`, this.information)
          .then(() => {
            this.status = true;
            this.$toast.success(trans('app.actions.saved', {name: trans('app.pages.settings.index').toLowerCase()}));
            if (this.information.preview) {
              setTimeout(() => {
                window.location.reload(true);
              }, 500);
            }
          })
          .catch((error) => {
            this.status = false;
            if (error.response && error.response.status === 422) {
              this.$toast.error(trans('app.save_failed'));
            } else {
              this.sentryCaptureException(error);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    updatePayments() {
      this.isLoading = true;
      axios.put(`/administrator/settings/payments`, this.payments)
          .then(() => {
            this.status = true;
            this.$toast.success(trans('app.actions.saved', {name: trans('app.pages.settings.index').toLowerCase()}));
          })
          .catch((error) => {
            this.status = false;
            if (error.response && error.response.status === 422) {
              this.$toast.error(trans('app.save_failed'));
            } else {
              this.sentryCaptureException(error);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    filesChange($event) {
      this.filesValid = true;
      this.selectedFilesLabels = '';
      let files = [];
      Object.values($event.target.files).forEach(file => {
        files.push(file.name);
      })
      this.selectedFilesLabels = files.join(', ');
    },
    filesButtonClick() {
      this.$refs.image.click();
    },
    removeFile() {
      this.isLoading = true;
      let formData = new FormData();
      formData.set('remove_file', true);
      axios.post(`/administrator/settings/promotion?_method=PUT`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(() => {
        this.status = true;
        this.loadSettings();
      }).catch((error) => {
        this.status = false;
        this.sentryCaptureException(error);
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }
}
</script>
